import type { Role } from '../../lib/sessionContext';

/** Guía de UX por rol (la autorización real está en qr-api, R1.2). */
export function permissionsFor(role: Role | undefined) {
  const manager = role === 'owner' || role === 'admin' || role === 'operator';
  return {
    manageLots: manager,
    manageLifecycle: manager,
    editDestination: manager || role === 'editor' || role === 'seller',
    createQr: manager || role === 'editor',
    chooseDomain: role === 'operator',
    ownOnly: role === 'seller',
  };
}
